import { browserHistory } from 'react-router';
import axios from 'axios';

const baseEndpoint = 'v1/report';

const ReportService = {
  getDashboardReports1(params) {
    return axios.get(`${baseEndpoint}/dashboard-1`, { params });
  },

  getDashboardReports2(params) {
    return axios.get(`${baseEndpoint}/dashboard-2`, { params });
  },
  getReportsExecutiveSummary(params) {
    return axios.get(`${baseEndpoint}/reportexecutivesummary`, { params });
  },

  getReportsEntriesPerHours(params) {
    return axios.get(`${baseEndpoint}/reportentriesperuserhours`, { params });
  },

  getReportsEntriesDismissed(params) {
    return axios.get(`${baseEndpoint}/reportsdismissedperuser`, { params });
  },

  getReportsEntriesPerCategory(params) {
    return axios.get(`${baseEndpoint}/reportentriespercategory`, { params });
  },

  getReportsEntriesPerUser(params) {
    return axios.get(`${baseEndpoint}/reportentriesperuser`, { params });
  },

  getReportsActivityByUser(dates, download) {
    if (download !== ''){
      return axios.post(`${baseEndpoint}/reportactivityperuser?download=${download}`, { dates });
    } else {
      return axios.post(`${baseEndpoint}/reportactivityperuser`, { dates });
    }
    
  },

  getReportsUptime(params) {
    return axios.get(`v1/app-status/percent_day`, { params });
  },
  
  getReportsUptimeIncidents(params) {
    return axios.get(`v1/app-status/incidents`, { params });
  },
  
  getReportsService(params) {
    return axios.get(`v1/app-status/report`, { params });
  }
};

export default ReportService;



// WEBPACK FOOTER //
// ./services/ReportService.js